export default "__VITE_ASSET__CyWeTJUy__"